import React, { useState } from 'react';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AdminLoginGate = ({ children }) => {
  const { isAuthenticated, login, loginError } = useAdminAuth();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return children;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-romantic-md border border-border max-w-md w-full p-6 md:p-8">
        <div className="text-center mb-6">
          <div className="w-14 h-14 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="Lock" size={24} color="var(--color-primary)" />
          </div>
          <h2 className="text-2xl font-semibold text-foreground mb-2">Admin Access</h2>
          <p className="text-sm text-muted-foreground">Enter the admin password to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Password"
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={loginError}
            required
          />
          <Button
            type="submit"
            variant="default"
            size="lg"
            fullWidth
            loading={loading}
            iconName="LogIn"
            iconPosition="right"
          >
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginGate;
